import React from 'react';
import { InstagramIcon, TwitterIcon, YoutubeIcon, MusicIcon, ArrowUpRightIcon } from 'lucide-react';
const SOCIALS = [{
  Icon: InstagramIcon,
  label: 'Instagram'
}, {
  Icon: TwitterIcon,
  label: 'X'
}, {
  Icon: YoutubeIcon,
  label: 'YouTube'
}, {
  Icon: MusicIcon,
  label: 'TikTok'
}];
const LINKS = [{
  label: 'Careers',
  external: true
}, {
  label: 'Privacy Policy',
  external: false
}, {
  label: 'Accessibility',
  external: false
}, {
  label: 'Sitemap',
  external: false
}];
/* repeated chevrons flanking the brand line */
const CHEVRONS_LEFT = '<'.repeat(200);
const CHEVRONS_RIGHT = '>'.repeat(200);
export function Footer() {
  return <footer id="join" className="w-full bg-black px-5 pb-10 pt-20 sm:px-8 lg:px-12" data-id="element-94">
      <div className="mx-auto max-w-7xl" data-id="element-95">
        {/* Top rule */}
        <div className="h-px w-full bg-white/25" aria-hidden="true" data-id="element-96" />

        {/* Socials — right aligned */}
        <div className="mt-8 flex justify-end gap-3" data-id="element-97">
          {SOCIALS.map(({
          Icon,
          label
        }) => <a key={label} href="#top" aria-label={label} className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-black transition-transform duration-300 hover:scale-105" data-id="element-98">
              <Icon className="h-5 w-5" data-id="element-99" />
            </a>)}
        </div>

        {/* Chevron band with the brand line in the gap */}
        <div className="mt-16 flex items-center gap-5 sm:gap-8" data-id="element-100">
          <div className="flex-1 select-none overflow-hidden whitespace-nowrap text-right font-archivo text-sm tracking-[0.15em] text-white/25" aria-hidden="true" data-id="element-101">
            {CHEVRONS_LEFT}
          </div>
          <p className="shrink-0 whitespace-nowrap text-center text-sm font-medium uppercase tracking-[0.25em] text-white/80 sm:text-base" data-id="element-102">
            Aenigma <span className="text-white/40" data-id="element-103">&mdash;</span> Fashion That
            Moves Culture
          </p>
          <div className="flex-1 select-none overflow-hidden whitespace-nowrap text-left font-archivo text-sm tracking-[0.15em] text-white/25" aria-hidden="true" data-id="element-104">
            {CHEVRONS_RIGHT}
          </div>
        </div>

        {/* Bottom meta row */}
        <div className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-end sm:gap-10" data-id="element-105">
          <p className="text-xs uppercase tracking-[0.2em] text-white/35" data-id="element-106">
            &copy; {new Date().getFullYear()} Aenigma
          </p>
          <nav aria-label="Footer" className="flex flex-wrap items-center gap-x-8 gap-y-3" data-id="element-107">
            {LINKS.map(l => <a key={l.label} href="#top" className="group inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-white/35 transition-colors hover:text-white" data-id="element-108">
                {l.label}
                {l.external && <ArrowUpRightIcon className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-109" />}
              </a>)}
          </nav>
        </div>
      </div>
    </footer>;
}